import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { LikeSuccess, ProductActionTypes } from '../actions';
import { PriceDropService } from '@app/shared/services/price-drop/priceDrop.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class ProductEffects {
  @Effect({ dispatch: false })
  likeSuccess$ = this.actions$.pipe(
    ofType(ProductActionTypes.LikeSuccess),
    tap((action: LikeSuccess) => this.priceDropService.addPriceDropToLocalForage(action.payload.id))
  );

  constructor(private actions$: Actions, private priceDropService: PriceDropService) {}
}
